var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button-wrappe",class:[_vm.type,{'border':_vm.border}, {disabled: _vm.disabled}],attrs:{"href":"javascript:;"},on:{"click":_vm.clickButton}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }